(function() {
  // SCROLL ANIMATIONS
  const fadeEls = document.querySelectorAll('.guide-fade');
  if (fadeEls.length) {
    const fadeObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          fadeObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    fadeEls.forEach(el => fadeObserver.observe(el));
  }

  // ACTIVE NAV STATE ON SCROLL
  const sections = document.querySelectorAll('section[id]');
  const navLinks = document.querySelectorAll('.guide-nav-link');

  if (sections.length && navLinks.length) {
    const navObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          navLinks.forEach(l => l.classList.remove('is-active'));
          const active = document.querySelector(
            `.guide-nav-link[data-section="${entry.target.id}"]`
          );
          if (active) active.classList.add('is-active');
        }
      });
    }, {
      rootMargin: '-30% 0px -60% 0px',
      threshold: 0
    });
    sections.forEach(s => navObserver.observe(s));
  }

  // SMOOTH SCROLL FOR NAV LINKS
  navLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.querySelector(
        `#${link.dataset.section}`
      );
      if (!target) return;
      const headerHeight = document.querySelector('.site-header')
        ?.offsetHeight || 68;
      const navHeight = document.querySelector('.guide-section-nav')
        ?.offsetHeight || 44;
      const top = target.getBoundingClientRect().top
        + window.scrollY - headerHeight - navHeight - 16;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });

})();